import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'components/AuthGuard';

const Clienti = Loadable(lazy(() => import('pages/Clienti.jsx')));
const Magazzino = Loadable(lazy(() => import('pages/Magazzino.jsx')));
const Giacenze = Loadable(lazy(() => import('pages/Giacenze.jsx')));
const MovimentiGiacenza = Loadable(lazy(() => import('pages/MovimentiGiacenza.jsx')));
const GestioneFidelity = Loadable(lazy(() => import('pages/GestioneFidelity.jsx')));
const MobileInventory = Loadable(lazy(() => import('pages/MobileInventory.jsx')));
const FattureElettroniche = Loadable(lazy(() => import('pages/FattureElettroniche.jsx')));
const CampaignManager = Loadable(lazy(() => import('pages/marketing/Campaigns.jsx')));
const PromoAnalytics = Loadable(lazy(() => import('pages/marketing/PromoAnalytics.jsx')));
const GestioneInventari = Loadable(lazy(() => import('pages/GestioneInventari.jsx')));
const Operazioni = Loadable(lazy(() => import('pages/Operazioni.jsx')));
const OperazioniVeca = Loadable(lazy(() => import('pages/OperazioniVeca.jsx')));
const AssistenteAdmin = Loadable(lazy(() => import('pages/AssistenteAdmin.jsx')));

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'clienti',
      element: <Clienti />
    },
    {
      path: 'magazzino',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <Magazzino />
        </AuthGuard>
      )
    },
    {
      path: 'giacenze',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <Giacenze />
        </AuthGuard>
      )
    },
    {
      path: 'movimenti-giacenza',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <MovimentiGiacenza />
        </AuthGuard>
      )
    },
    {
      path: 'mobile-inventory',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <MobileInventory />
        </AuthGuard>
      )
    },
    {
      path: 'inventari',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <GestioneInventari />
        </AuthGuard>
      )
    },
    {
      path: 'operazioni',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <Operazioni />
        </AuthGuard>
      )
    },
    {
      path: 'operazioni-veca',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <OperazioniVeca />
        </AuthGuard>
      )
    },
    {
      path: 'fatture-elettroniche',
      element: (
        <AuthGuard requiredRoles={['admin', 'ufficio']}>
          <FattureElettroniche />
        </AuthGuard>
      )
    },
    {
      path: 'fidelity',
      element: <GestioneFidelity />
    },
    {
      path: 'assistente-admin',
      element: (
        <AuthGuard requiredRoles={['admin']}>
          <AssistenteAdmin />
        </AuthGuard>
      )
    },
    {
      path: 'marketing',
      children: [
        {
          path: 'campaigns',
          element: (
            <AuthGuard requiredRoles={['admin', 'ufficio']}>
              <CampaignManager />
            </AuthGuard>
          )
        },
        {
          path: 'analytics',
          element: (
            <AuthGuard requiredRoles={['admin', 'ufficio']}>
              <PromoAnalytics />
            </AuthGuard>
          )
        }
      ]
    }
  ]
};

export default MainRoutes;
